import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Breadcrumbs, Grid, Typography } from "@material-ui/core";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { getPictreePlotEventData } from "actions";
import * as C from "components";
import CalendarRangePickerPlot from "components/Calendar/CalendarRangePickerPlot";
import PlotEventTable from "components/PicTree/Plot/PlotEventTable";

const PLOT_LIST_MIN_DATE = "2026/08/01";

const useStyles = makeStyles((theme) =>
  createStyles({
    page: {
      paddingBottom: theme.spacing(3),
    },
    breadcrumbs: {
      marginTop: 16,
      minHeight: 30,
    },
    topRow: {
      marginTop: -16,
      marginBottom: 8,
      alignItems: "center",
    },
    description: {
      color: "#6b7280",
      fontSize: 12,
      marginTop: theme.spacing(1),
    },
  })
);

const PicTreePlotEventList = ({
  eventRows,
  eventLoading,
  getPictreePlotEventData,
  dateRangePicTree,
}) => {
  const classes = useStyles();
  const [initialDataCall, setInitialDataCall] = useState(true);

  useEffect(() => {
    if (
      initialDataCall &&
      Array.isArray(dateRangePicTree) &&
      dateRangePicTree[0] !== null &&
      dateRangePicTree[1] !== null
    ) {
      getPictreePlotEventData();
      setInitialDataCall(false);
    }
  }, [dateRangePicTree, initialDataCall, getPictreePlotEventData]);

  return (
    <Fragment>
      <C.ContentWrapper>
        <div className={classes.page}>
          <Grid container direction="row" justifyContent="space-between" className={classes.topRow}>
            <Grid item>
              <Breadcrumbs separator="›" className={classes.breadcrumbs}>
                <Typography>PicTrée</Typography>
                <Typography variant="body1">プロット機能</Typography>
                <Typography variant="body1">プロット一覧</Typography>
              </Breadcrumbs>
            </Grid>
            <Grid item />
            <Grid item>
              <CalendarRangePickerPlot
                mDate={PLOT_LIST_MIN_DATE}
                page="pictree"
                pictree
                timeselect={false}
                singleSelect={true}
                allowOutOfSeason={true}
                defaultRangeDays={7}
                fetchFilterEventOptions={false}
                fetchFilterMunicipalityOptions={false}
                onGoClick={getPictreePlotEventData}
              />
            </Grid>
          </Grid>
          <PlotEventTable rows={eventRows} loading={eventLoading} />
        </div>
      </C.ContentWrapper>
    </Fragment>
  );
};

PicTreePlotEventList.propTypes = {
  eventRows: PropTypes.arrayOf(PropTypes.array),
  eventLoading: PropTypes.bool,
  dateRangePicTree: PropTypes.array,
};

PicTreePlotEventList.defaultProps = {
  eventRows: [],
  eventLoading: false,
  dateRangePicTree: [null, null],
};

const mapStateToProps = (state) => ({
  eventRows: state.pictreePlot.eventRows,
  eventLoading: state.pictreePlot.eventLoading,
  dateRangePicTree: state.page.dateRangePicTree,
});

const mapDispatchToProps = (dispatch) => ({
  getPictreePlotEventData: (param) => dispatch(getPictreePlotEventData(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PicTreePlotEventList);
